import {Component, input} from '@angular/core';
import {Step31SystemOverviewComponent} from '../../../../../chapter-3-system-capture/step-3-1-system-recording/step-3-1-system-overview/step-3-1-system-overview.component';
import {SystemFlowComponent} from '../../../../../chapter-3-system-capture/step-3-2-system-flow/components/system-flow/system-flow.component';
import {AppPanelComponent} from '../../../../../../../../../shared/components/header/panel/app-panel.component';

@Component({
  selector: 'app-system-recording-integration-panels',
  imports: [Step31SystemOverviewComponent, SystemFlowComponent, AppPanelComponent],
  templateUrl: './system-recording-integration-panels.component.html',
})
export class SystemRecordingIntegrationPanelsComponent {
  readonly projectId = input.required<number>();
  readonly currentOfficeSystemRecording = input.required<any>();
  readonly targetOfficeSystemRecording = input.required<any>();
  readonly integrationSystemRecordings = input.required<any>();
}
